import { useQuery } from 'react-query';

import { getVersionSummaryCards as queryFn } from 'api/endPoints/getVersionSummaryCards';

export const useQuerySummaryData = (params) => {
    return useQuery(['summaryDataLine', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId),
        cacheTime: 0,
    });
};
